export default __webpack_public_path__ + "static/media/kerpen_light.998a9adf.png";